//hack for project page
export default {
  list: { lazy: () => import('./ProjectsListEntry') },
  edit: null,
  create: null,
  options: {
    show: {
      subtitle: null,
      breadCrumb: 'Edit Project',
    },
    list: {
      //hide bread crumb and use custom project selector dropdown as title
    },
    create: {
      // auto generate default title and bread crumb for create
    },
  },
}
